import { render, staticRenderFns } from "./nocont.vue?vue&type=template&id=0d47c7a0&scoped=true&"
import script from "./nocont.vue?vue&type=script&lang=js&"
export * from "./nocont.vue?vue&type=script&lang=js&"
import style0 from "./nocont.vue?vue&type=style&index=0&id=0d47c7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d47c7a0",
  null
  
)

export default component.exports